// Web-only polyfills that MUST run before any other module evaluates.
// Keep this import first in index.web.js.
import { Platform } from 'react-native';

// react-native-web's Platform has no `constants`. Several native libraries
// (e.g. @sendbird/uikit-react-native) read `Platform.constants.reactNativeVersion`
// at module-evaluation time and crash the whole bundle if it's missing.
if (!Platform.constants) {
  Platform.constants = {
    reactNativeVersion: { major: 0, minor: 81, patch: 0 },
  };
}
